import React, { useEffect, useState } from 'react';
export function MobileStickyTopBar() {
  const messages = ['⚠️ Hoy accedés con BONOS activos + precio reducido', '💌 Acceso inmediato por email + garantía de 7 días', '🔒 Pago 100% seguro con Mercado Pago'];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % messages.length);
        setIsAnimating(false);
      }, 300);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('precio');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-[#1A1208] to-[#2A1F0F] border-b border-gold/30 py-2.5 px-4 md:hidden shadow-lg cursor-pointer" onClick={scrollToPricing} role="button" tabIndex={0} onKeyDown={e => {
    if (e.key === 'Enter' || e.key === ' ') {
      scrollToPricing();
    }
  }} data-id="element-38">
      <div className="max-w-md mx-auto text-center overflow-hidden" data-id="element-39">
        <p className={`text-white text-[13px] font-semibold leading-tight transition-all duration-300 ${isAnimating ? 'opacity-0 translate-y-2' : 'opacity-100 translate-y-0'}`} data-id="element-40">
          {messages[currentIndex]}
        </p>
      </div>
    </div>;
}